import { retrieveTheme, retrievePageContent, getSuperCategories, getTourismPartner, getContent, getOffers, retrieveStores, getRetailers, retrieveTourismOffers, retrieveOffers, retrieveRetailers } from './lib/storyBlok'
import { sendOfferRedemption, retrieveUserRedemptions } from './lib/redemption'
import { validateUrl, saveUserInStorage, login } from './lib/registration'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export function fetchContent() {
    return async (dispatch, getState) => {
        const state = getState();

        if (!state.theme) {
            dispatch(requestContent());

            const [user, offers, content, superCategories] =
                await Promise.all([
                     fetchUser(),
                     getOffers(),
                     getContent(),
                     getSuperCategories()
                    // getTourismPartner(), //The centre asked to take this out. I am not sure if it is permanent or temp. So I just commented out this line to improve the performance
                ])

            dispatch(
                receiveContent(content)
            )

            dispatch(
                receiveOffers(retrieveOffers(offers))
            )

            dispatch(
                receiveTheme(retrieveTheme(content))
            )

            dispatch(
                receivePageContent(retrievePageContent(content))
            )

            dispatch(
                receiveSuperCategories(superCategories)
            )

            // dispatch(
            //     receiveTourismOffers(retrieveTourismOffers(tourismPartners))
            // )

            const stores = retrieveStores(offers)

            dispatch(
                receiveStores(stores)
            )

            dispatch(
                receiveRetailers(retrieveRetailers(stores))
            )

            dispatch(user)
        }
    }
}

export function fetchUser() {
    return (dispatch, getState) => {
        const state = getState();
        let userData;

        if (!state.user) {
            dispatch(requestUser());

            return validateUrl()
                .then((data) => {
                    if (data.type == 'Error' || data.type == 'RegistrationVerificationError') {
                        dispatch(registrationVerificationError(data))

                        throw new Error(data.message)
                    }

                    return data
                }).then((data) => {
                    saveUserInStorage(data)

                    return data
                }).then((data) => {
                    return login(data)
                }).then((data) => {
                    userData = data

                    return retrieveUserRedemptions(data.userId)
                }).then(redemptions => {
                    dispatch(userRedemptions(redemptions))
                    dispatch(receieveUser(userData))
                })
                .catch((error) => {
                    dispatch(registrationVerificationError(error))
                })
        }
    }
}

export function redeemOffer(offer) {
    return (dispatch, getState) => {
        dispatch(startingOfferRedemption(offer))

        const { user } = getState()

        login(user).then(() => {
            sendOfferRedemption(user.userId, offer.id).then(result => {
                if (result.type && result.type == 'DuplicateRedemptionError') {
                    dispatch(failedOfferRedemption(offer, result.message))
                } else {
                    dispatch(hideRedeemModal())
                    dispatch(finishedOfferRedemption(offer))
                }
            }, reason => {
                dispatch(failedOfferRedemption(offer, reason.message))
            })
        }).catch((error) => {
            dispatch(registrationVerificationError(error))
        })
    }
}

export function showRedeemModal(offer) {
    return (dispatch, getState) => {
        const { modalRef } = getState()

        dispatch(setRedeemModalOffer(offer))
        disableBodyScroll(modalRef)
    }
}

export function hideRedeemModal() {
    return (dispatch, getState) => {
        const { modalRef } = getState()

        dispatch(removeRedeemModalOffer())
        clearAllBodyScrollLocks()
    }
}

export function toggleFilterMenu() {
    return (dispatch, getState) => {
        const { filterMenuRef, filterMenuOpen } = getState()

        if (filterMenuOpen) {
            clearAllBodyScrollLocks()
        } else {
            disableBodyScroll(filterMenuRef)
        }

        dispatch(setFilterMenuState(!filterMenuOpen))
    }
}

export function selectFilterOption(slug) {
    return (dispatch, getState) => {
        dispatch(toggleFilterMenu())
        dispatch(setFilterOption(slug))
    }
}

export const OFFERS_RESPONSE = 'OFFERS_RESPONSE'
export const receiveOffers = (offerData) => {
    return {
        type: OFFERS_RESPONSE,
        payload: offerData
    }
}

export const OFFERS_REQUEST_FAILURE = 'OFFERS_REQUEST_FAILURE'
export const triggerError = (error) => {
    return {
        type: OFFERS_REQUEST_FAILURE,
        payoad: error
    }
}

export const USER_REQUEST = 'USER_REQUEST'
export const requestUser = () => {
    return {
        type: USER_REQUEST
    }
}

export const USER_RESPONSE = 'USER_RESPONSE'
export const receieveUser = (userData) => {
    return {
        type: USER_RESPONSE,
        payload: userData
    }
}

export const REGISTRATION_VERIFICATION_ERROR = 'REGISTRATION_VERIFICATION_ERROR'
export const registrationVerificationError = (error) => {
    return {
        type: REGISTRATION_VERIFICATION_ERROR,
        payload: error
    }
}

export const USER_REDEMPTIONS = 'USER_REDEMPTIONS'
export const userRedemptions = (redemptions) => {
    return {
        type: USER_REDEMPTIONS,
        payload: redemptions
    }
}

export const CONTENT_REQUEST = 'CONTENT_REQUEST'
export const requestContent = () => {
    return {
        type: CONTENT_REQUEST
    }
}

export const CONTENT_RESPONSE = 'CONTENT_RESPONSE'
export const receiveContent = (content) => {
    return {
        type: CONTENT_RESPONSE,
        payload: content
    }
}

export const THEME_RESPONSE = 'THEME_RESPONSE'
export const receiveTheme = (theme) => {
    return {
        type: THEME_RESPONSE,
        payload: theme
    }
}
export const PAGECONTENT_RESPONSE = 'PAGECONTENT_RESPONSE'
export const receivePageContent = (pageContent) => {
    return {
        type: PAGECONTENT_RESPONSE,
        payload: pageContent
    }
}

export const SUPERCATEGORY_RESPONSE = 'SUPERCATEGORY_RESPONSE'
export const receiveSuperCategories = (superCategories) => {
    return {
        type: SUPERCATEGORY_RESPONSE,
        payload: superCategories
    }
}

export const STORE_RESPONSE = 'STORE_RESPONSE'
export const receiveStores = (stores) => {
    return {
        type: STORE_RESPONSE,
        payload: stores
    }
}

export const RETAILER_RESPONSE = 'RETAILER_RESPONSE'
export const receiveRetailers = (retailers) => {
    return {
        type: RETAILER_RESPONSE,
        payload: retailers
    }
}

export const TOURISM_RESPONSE = 'TOURISM_RESPONSE'
export const receiveTourismOffers = (tourismRetailers) => {
    return {
        type: TOURISM_RESPONSE,
        payload: tourismRetailers
    }
}

export const SET_FILTER_MENU_STATE = 'SET_FILTER_MENU_STATE'
export const setFilterMenuState = (state) => {
    return {
        type: SET_FILTER_MENU_STATE,
        payload: state
    }
}

export const SET_FILTER_MENU_REF = 'SET_FILTER_MENU_REF'
export const setFilterMenuRef = (menu) => {
    return {
        type: SET_FILTER_MENU_REF,
        payload: menu
    }
}

export const SELECT_FILTER_OPTION = 'SELECT_FILTER_OPTION'
export const setFilterOption = slug => {
    return {
        type: SELECT_FILTER_OPTION,
        payload: slug
    }
}

export const SET_ACTIVE_RETAILER = 'SELECT_ACTIVE_RETAILER'
export const setActiveRetailer = retailer => {
    return {
        type: SELECT_ACTIVE_RETAILER,
        payload: retailer
    }
}

export const SHOW_MORE_INFO = 'SHOW_MORE_INFO'
export const showMoreInfo = offer => {
    return {
        type: SHOW_MORE_INFO,
        payload: offer
    }
}

export const HIDE_MORE_INFO = 'HIDE_MORE_INFO'
export const hideMoreInfo = offer => {
    return {
        type: HIDE_MORE_INFO,
        payload: offer
    }
}

export const SET_REDEEM_MODAL_OFFER = 'SET_REDEEM_MODAL_OFFER'
export const setRedeemModalOffer = offer => {
    return {
        type: SET_REDEEM_MODAL_OFFER,
        payload: offer
    }
}

export const REMOVE_REDEEM_MODAL_OFFER = 'REMOVE_REDEEM_MODAL_OFFER'
export const removeRedeemModalOffer = () => {
    return {
        type: REMOVE_REDEEM_MODAL_OFFER
    }
}

export const SET_MODAL_REF = 'SET_MODAL_REF'
export const setModalRef = modal => {
    return {
        type: SET_MODAL_REF,
        payload: modal
    }
}

export const STARTING_OFFER_REDEMPTION = 'STARTING_OFFER_REDEMPTION'
export const startingOfferRedemption = offer => {
    return {
        type: STARTING_OFFER_REDEMPTION,
        payload: offer
    }
}

export const FINISHED_OFFER_REDEMPTION = 'FINISHED_OFFER_REDEMPTION'
export const finishedOfferRedemption = offer => {
    return {
        type: FINISHED_OFFER_REDEMPTION,
        payload: offer
    }
}

export const FAILED_OFFER_REDEMPTION = 'FAILED_OFFER_REDEMPTION'
export const failedOfferRedemption = (offer, error) => {
    return {
        type: FAILED_OFFER_REDEMPTION,
        payload: {
            offer,
            error
        }
    }
}

export const SET_REDEEMED_OFFER_REF = 'SET_REDEEMED_OFFER_REF'
export const setRedeemedOfferRef = ref => {
    return {
        type: SET_REDEEMED_OFFER_REF,
        payload: ref
    }
}

export const REMOVE_REDEEMED_OFFER_REF = 'REMOVE_REDEEMED_OFFER_REF'
export const removeRedeemedOfferRef = () => {
    return {
        type: REMOVE_REDEEMED_OFFER_REF,
    }
}


// WEBPACK FOOTER //
// ./actions.js